import { createApiClient, getAuthHeaders } from "@/lib/api-client";

import type {
  AuditEventCursor,
  AuditEventEntry,
  AuditEventsQuery,
  AuditEventsResponse,
} from "./audit-log-types";

const auditApi = createApiClient({
  baseUrl: `${import.meta.env.VITE_API_URL ?? "http://localhost:3001"}/identity`,
  getAuthHeaders,
});

export async function fetchAuditLogs(query: AuditEventsQuery): Promise<{
  entries: readonly AuditEventEntry[];
  hasMore: boolean;
  nextCursor: AuditEventCursor | null;
}> {
  const params = new URLSearchParams();
  params.set("enterprise_id", query.enterprise_id);

  if (query.org_unit_id) {
    params.set("org_unit_id", query.org_unit_id);
  }
  if (query.action) {
    params.set("action", query.action);
  }
  if (query.limit !== undefined) {
    params.set("limit", String(query.limit));
  }
  if (query.cursor_created_at !== undefined) {
    params.set("cursor_created_at", query.cursor_created_at);
  }
  if (query.cursor_id !== undefined) {
    params.set("cursor_id", query.cursor_id);
  }

  const response = await auditApi.get<AuditEventsResponse>(`/audit-events?${params.toString()}`);
  return {
    entries: response.data,
    hasMore: response.meta.has_more,
    nextCursor: response.meta.next_cursor,
  };
}
